// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import $ from "jquery";
import VueI18n from "vue-i18n"; //引入vue-i18n
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import App from "./App";
import router from "./router";
import store from "./store";
import "babel-polyfill";
import "./permission";
import "../static/iconfonts/iconfont.css";
import {
  Input,
  Button,
  Radio,
  Pagination,
  Table,
  TableColumn,
  Breadcrumb,
  BreadcrumbItem,
  Select,
  Option,
  OptionGroup,
  MessageBox,
  Message,
  Checkbox,
  Dialog,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Image,
  DatePicker,
  Upload,
  Loading,
  Carousel,
  CarouselItem,
  Row,
  Col,
  Menu,
  MenuItemGroup,
  Submenu,
  MenuItem
} from "element-ui";
import echarts from "echarts";

Vue.config.productionTip = false;
Vue.use(VueI18n); //通过插件的形式挂载
Vue.use(Pagination)
  .use(Table)
  .use(Radio)
  .use(TableColumn)
  .use(Breadcrumb)
  .use(BreadcrumbItem)
  .use(Select)
  .use(Option)
  .use(OptionGroup)
  .use(Checkbox)
  .use(Dialog)
  .use(Button)
  .use(Dropdown)
  .use(DropdownMenu)
  .use(DropdownItem)
  .use(Input)
  .use(Image)
  .use(DatePicker)
  .use(Upload)
  .use(Loading)
  .use(Carousel)
  .use(CarouselItem)
  .use(Row)
  .use(Col)
  .use(Menu)
  .use(MenuItemGroup)
  .use(Submenu)
  .use(MenuItem);
// Vue.use(vant.NoticeBar)
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$message = Message;

const i18n = new VueI18n({
  locale: "zh", // 语言标识
  silentFallbackWarn: true,
  messages: {
    zh: Object.assign(require("@/components/lang/zh")), //这里需要注意一下，是如何导入多个语言包的
    en: Object.assign(require("@/components/lang/en"))
  }
});

let HOST = process.env.HOST;
let url = "";
switch (HOST) {
  case "dev":
    url = "http://mobile.weixiao.test.weiguyun.com";
    break;
  case "prod":
    url = "https://mobile.weixiao.ct-study.com.cn";
    break;
  case "test":
    url = "http://mobile.weixiao.test.weiguyun.com";
    break;
}

Vue.prototype.$phoneHtml = url;
Vue.prototype.$echarts = echarts;
Vue.prototype.$showPhone = false;
window.$phoneHtml = Vue.prototype.$phoneHtml;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  i18n,
  components: { App },
  render: h => h(App),
  template: "<App/>"
});

// WEBPACK FOOTER //
// ./src/main.js



// WEBPACK FOOTER //
// ./src/main.js